module.exports = __webpack_public_path__ + "img/c94df2983c6140f4a54e9d4f957f5073-1024.cc220f11.jpg";